import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function fetchExtraTypeConfigList(offset = 0, limit = 5000) {
  const response = await getAPIResponse(`/v1/extra-type-configs`, { offset, limit }, "GET");
  return response?.items || [];
}

export async function fetchExtraTypeConfigById(id) {
  return await getAPIResponse(`/v1/extra-type-configs/${id}`, null, "GET");
}

export async function createExtraTypeConfig(data) {
  return await getAPIResponse("/v1/extra-type-configs", data, "POST");
}

export async function updateExtraTypeConfig(id, data) {
  return await getAPIResponse(`/v1/extra-type-configs/${id}`, data, "PUT");
}

export async function deleteExtraTypeConfig(id) {
  return await getAPIResponse(`/v1/extra-type-configs/${id}`, null, "DELETE");
}

export async function fetchExtraTypeList() {
  const response = await getAPIResponse("/v1/extra-types", { offset: 0, limit: 5000 }, "GET");
  return response?.items || [];
}

export async function createExtraType(data) {
  return await getAPIResponse("/v1/extra-types", data, "POST");
}

export async function updateExtraType(id, data) {
  return await getAPIResponse(`/v1/extra-types/${id}`, data, "PUT");
}

export async function deleteExtraType(id) {
  return await getAPIResponse(`/v1/extra-types/${id}`, null, "DELETE");
}
